export default {
  path: '/selos',
  component: () => import('@/components/pages/Seals/Seals')
}
